import script from "./Transactions.vue?vue&type=script&setup=true&lang=ts"
export * from "./Transactions.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import qInstall from "../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable});
